import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/employee.actions';
import * as home from '../../../../actions/process.home.actions';

import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import AvatarDialog from '../../../dialogs/Avatar';
import Snackbar from '../../../labels/Snackbar';
import Menu from '../Menu';
import Tree from './Tree';

import { BlueTickIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function isOk(field) {
    return field === undefined || field.length < 2;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0
        ? intl.formatMessage({ id: 'required' })
        : field.length < 2
            ? intl.formatMessage({ id: 'min_length_2' })
            : '';
}

function toolbar(id, handleDelete, isCorrect, handleSummit) {

    const deleteButton = id ? (
        <TrashIcon
            key="delete-post-display"
            className="hand"
            color="secondary"
            onClick={handleDelete}
        />
    ) : null;

    const saveButton = isCorrect ? (
        <BlueTickIcon
            key="submmit-post-employee"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    ) : null;
    return [
        saveButton,
        deleteButton
    ];
}


class Employee extends React.Component {

    state = {
        employee: undefined,
        nombre: '',
        apellidos: '',
        documento: '',
        consentimiento: false,
        locales: [],
        foto: undefined,
        avatarDialog: false,
        esUsuario: false,
    };

    constructor(props) {
        super(props);
        if (props.id) {
            props.loadInfo(props.id);
        }
    }

    componentDidUpdate() {
        const tools = [toolbar(this.props.id >= 0, this.handleDelete, this.isCorrect(), this.handleSummit)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { employee, id } = props;
        if (state.employee !== employee && employee && employee.id && employee.id.toString() === id) {
            const { nombre, apellidos, consentimiento, documento, locales, foto, esUsuario } = employee;
            state.nombre = nombre ? nombre : '';
            state.apellidos = apellidos ? apellidos : '';
            state.documento = documento ? documento : '';
            state.consentimiento = consentimiento ? true : false;
            state.locales = locales ? locales : [];
            state.foto = foto ? foto : undefined;
            state.esUsuario = esUsuario ? true : false;
            state.employee = employee;
            return state;
        }
        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    }

    handleClose = () => {
        this.setState({ error: '' });
    }

    handleChangeLocal = (id, name) => {
        const arr = [...this.state.locales];
        const index = arr.map((l) => l.id).indexOf(id);
        if(index >= 0) {
            arr.splice(index, 1);
        } else {
            arr.push({id: id, nombre: name});
        }
        console.log(id, name, arr);
        this.setState({ locales: arr })
    }

    openAvatarDialog = (event) => {
        this.setState({ avatarDialog: true });
    };

    closeAvatarDialog = (foto) => {
        console.log(foto);
        if (foto) {
            this.setState({ avatarDialog: false, foto: foto });
        } else {
            this.setState({ avatarDialog: false });
        }
    }

    isCorrect = () => {
        const { nombre, apellidos, locales } = this.state;
        return (
            nombre &&
            nombre.length > 1 &&
            apellidos &&
            apellidos.length > 1 &&
            locales &&
            locales.length > 0
        );
    }

    handleDelete = () => {

        if (this.props.id) {

            this.props
                .deleteEmployee(this.props.id)
                .then((r) => {
                    this.props.history.push('/manage/employees');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message });
                });
        }
    }

    handleSummit = () => {

        const {
            nombre,
            apellidos,
            consentimiento,
            locales,
            foto,
            esUsuario,
            documento
        } = this.state;

        const employee = {
            nombre: nombre,
            apellidos: apellidos,
            consentimiento: consentimiento,
            locales: locales,
            esUsuario: esUsuario,
            documento: documento
        }

        if (foto) {
            employee.foto = foto;
        }

        if (!this.props.id) {

            this.props
                .addEmployee(employee)
                .then((r) => {
                    this.props.history.push('/manage/employees');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });

        } else {

            employee.id = this.props.id;
            this.props
                .editEmployee(employee)
                .then((r) => {
                    this.props.history.push('/manage/employees');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    Field = (field, name, intl, autoFocus = false, disable = false, required = true) => (
        <TextField
            autoFocus={autoFocus}
            fullWidth
            disabled={disable}
            id={name}
            name={name}
            required={required}
            error={required && isOk(field)}
            helperText={required ? helperText(field, intl) : ''}
            label={intl.formatMessage({ id: 'form_field_name_' + name })}
            className={'flex_full_row'}
            value={field}
            onChange={this.handleChange}
            margin="normal"
            InputLabelProps={{ shrink: true }}
        />
    );

    render() {

        const {
            nombre,
            apellidos,
            consentimiento,
            locales,
            esUsuario,
            error,
            errorType,
            foto,
            avatarDialog,
            documento
        } = this.state;
        const { intl, id, employees_is_loading, employees_has_errored, info } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '84' || f === '20') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && employees_has_errored.hasErrored) {
            return <Error open type={employees_has_errored.hasErrored}  message={employees_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {employees_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white employee showbar'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll showbar "
                                onScroll={this.handleScroll}
                            >
                                <div
                                    className="width100 bg_ice_blue shadow"
                                    style={{ height: '85px' }}
                                />
                                <div className="flex_full_row center">
                                    <Avatar className={'avatar-user-menu'}>
                                        {foto && (
                                            <img
                                                src={foto}
                                                alt="Preview"
                                                onClick={this.openAvatarDialog}
                                            />
                                        )}
                                        {!foto && (
                                            <AccountCircle
                                                className={'bg_bluish'}
                                                style={{ fontSize: 84 }}
                                                onClick={this.openAvatarDialog}
                                            />
                                        )}
                                    </Avatar>
                                </div>
                                <div className="flex_full_column padding_borders">
                                    {this.Field(nombre, 'nombre', intl)}
                                    {this.Field(apellidos, 'apellidos', intl)}
                                    {this.Field(documento, 'documento', intl, false, false, false)}

                                    <div className="flex_full_row margin_top_32 align_center">
                                        <div className="flex_full_column">
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_name_consentimiento" />
                                            </div>
                                        </div>
                                        <div className="flex_auto_column">
                                            <Switch
                                                name={'consentimiento'}
                                                checked={consentimiento}
                                                onChange={this.handleChecked}
                                                value="consentimiento"
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex_full_row margin_top_32 align_center">
                                        <div className="flex_full_column">
                                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                <FormattedMessage id="form_field_name_esUsuario" />
                                            </div>
                                        </div>
                                        <div className="flex_auto_column">
                                            <Switch
                                                disabled={true}
                                                name={'esUsuario'}
                                                checked={esUsuario}
                                                onChange={this.handleChecked}
                                                value="esUsuario"
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex_full_row margin_top_32">
                                        <Tree
                                            {...this.props}
                                            locales={locales} 
                                            onChange={this.handleChangeLocal}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {avatarDialog && (
                        <AvatarDialog 
                            open={true} 
                            handleClose={this.closeAvatarDialog} 
                        />
                    )}
                </div>
            );
        }
    }
}

Employee.propTypes = {
    intl: intlShape.isRequired,
}

const mapStateToProps = (state) => {
    return {
        employees_has_errored: state.employees_has_errored,
        employees_is_loading: state.employees_is_loading,
        employee: state.employee,
        info: state.info,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Employee)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/employee/Index.js